import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Filter, Search } from "lucide-react";

// Filtro colonna stile Excel: menu con ricerca interna + checkbox multi-selezione.
// values: array di stringhe grezze distinte. selected: Set|null (null = tutti).
export default function ColumnFilterMenu({ values = [], selected, onChange, format = (v) => v || "—", testid }) {
  const [q, setQ] = useState("");
  const active = selected && selected.size < values.length;
  const shown = values.filter((v) => format(v).toLowerCase().includes(q.trim().toLowerCase()));
  const isChecked = (raw) => !selected || selected.has(raw);
  const commit = (base) => onChange(base.size >= values.length ? null : base);
  const toggle = (raw) => {
    const base = selected ? new Set(selected) : new Set(values);
    if (base.has(raw)) base.delete(raw); else base.add(raw);
    commit(base);
  };
  const allShownChecked = shown.length > 0 && shown.every(isChecked);
  const toggleAll = () => {
    const base = selected ? new Set(selected) : new Set(values);
    if (allShownChecked) shown.forEach((v) => base.delete(v));
    else shown.forEach((v) => base.add(v));
    commit(base);
  };
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid={`col-filter-${testid}`} onClick={(e) => e.stopPropagation()}
          className={`rounded p-0.5 hover:bg-slate-300/60 flex-shrink-0 ${active ? "text-blue-600" : "text-slate-300"}`}>
          <Filter className={`h-3 w-3 ${active ? "fill-blue-600" : ""}`} />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-64 p-2" onClick={(e) => e.stopPropagation()}>
        <div className="relative mb-2">
          <Search className="absolute left-2 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-slate-400" />
          <Input data-testid={`col-filter-search-${testid}`} value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca…" className="pl-7 h-8 text-xs" />
        </div>
        <div className="flex items-center gap-1.5 px-1 py-1 border-b border-slate-100 mb-1">
          <button data-testid={`col-filter-all-${testid}`} onClick={() => onChange(null)}
            className="flex-1 text-[11px] font-medium text-blue-700 hover:bg-blue-50 rounded px-1.5 py-1">Seleziona tutto</button>
          <button data-testid={`col-filter-none-${testid}`} onClick={() => onChange(new Set())}
            className="flex-1 text-[11px] font-medium text-slate-500 hover:bg-slate-100 rounded px-1.5 py-1">Deseleziona tutto</button>
        </div>
        <div className="max-h-52 overflow-auto space-y-0.5">
          {shown.length === 0 ? <p className="text-xs text-slate-400 px-1 py-2">Nessun valore</p> : shown.map((raw) => (
            <label key={raw} className="flex items-center gap-2 px-1 py-1 rounded hover:bg-slate-50 cursor-pointer">
              <Checkbox checked={isChecked(raw)} onCheckedChange={() => toggle(raw)} data-testid={`col-filter-opt-${testid}`} />
              <span className="text-xs text-slate-700 normal-case tracking-normal truncate">{format(raw)}</span>
            </label>
          ))}
        </div>
        {active && (
          <Button variant="ghost" size="sm" data-testid={`col-filter-clear-${testid}`} onClick={() => onChange(null)} className="w-full mt-1 h-7 text-xs text-blue-700">Rimuovi filtro</Button>
        )}
      </PopoverContent>
    </Popover>
  );
}
